import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import { FULFILLMENT_TYPES } from 'actions/ActionsConstants';

const {
    EVENT_NAMES: { PAYPAL_EXPRESS },
    SOT_LINK_TRACKING_EVENT,
    LINK_TRACKING_EVENT
} = anaConsts;

class PayPalExpressBindings {
    static triggerSOTAnalytics = ({
        eventName, sotType, pageName, origin, paymentMethod, isClick = true, ...data
    }) => {
        const opts = {
            data: {
                linkName: eventName,
                actionInfo: eventName,
                specificEventName: eventName,
                sotType,
                pageName,
                origin,
                paymentMethod,
                ...data
            },
            finishEventWithoutTimeout: isClick
        };

        processEvent.process(SOT_LINK_TRACKING_EVENT, opts);
    };

    static trackSOTPayPalClick = ({
        eventName, sotType, pageName, origin, paymentMethod
    }) => {
        PayPalExpressBindings.triggerSOTAnalytics({
            eventName,
            sotType,
            pageName,
            origin,
            paymentMethod
        });
    };

    static trackSOTSetDefaultPayment = ({
        eventName, sotType, pageName, origin, paymentMethod, action
    }) => {
        PayPalExpressBindings.triggerSOTAnalytics({
            eventName,
            sotType,
            pageName,
            origin,
            paymentMethod,
            action
        });
    };

    /**
     * Track PayPal Express button click
     * @param {string} fulfillmentType - The fulfillment type (SHIP, SAMEDAY, PICKUP)
     * @param {string} pageContext - The page context ('basket' or 'checkout')
     */
    static trackPayPalExpressClick(fulfillmentType, pageContext = 'basket') {
        const isSddOrder = fulfillmentType === FULFILLMENT_TYPES.SAMEDAY;
        const pageName = `${pageContext}:paypal express:n/a:*`;

        processEvent.process(LINK_TRACKING_EVENT, {
            data: {
                pageName,
                pageDetail: isSddOrder ? PAYPAL_EXPRESS.PAGE_DETAIL.SAME_DAY_DELIVERY : PAYPAL_EXPRESS.PAGE_DETAIL.STANDARD,
                linkName: PAYPAL_EXPRESS.BUTTON_CLICK,
                internalCampaign: isSddOrder ? PAYPAL_EXPRESS.CAMPAIGN.PAYPAL_SDD_EXPRESS : PAYPAL_EXPRESS.CAMPAIGN.PAYPAL_EXPRESS,
                fulfillmentType
            }
        });
    }

    /**
     * Track PayPal SDD Express order placement (direct from paysheet)
     * @param {object} orderData - Order data
     * @param {string} orderData.orderId - The order ID
     * @param {number|string} orderData.total - The order total
     */
    static trackSddExpressOrderPlacement(orderData) {
        const { orderId, total } = orderData;

        processEvent.process(LINK_TRACKING_EVENT, {
            data: {
                pageName: 'paypal:sdd express:order placed:n/a:*',
                pageDetail: PAYPAL_EXPRESS.PAGE_DETAIL.SAME_DAY_DELIVERY_EXPRESS,
                linkName: PAYPAL_EXPRESS.SDD_ORDER_PLACED,
                orderId,
                orderTotal: total,
                internalCampaign: PAYPAL_EXPRESS.CAMPAIGN.PAYPAL_SDD_EXPRESS,
                actionInfo: PAYPAL_EXPRESS.ACTION_INFO.DIRECT_ORDER_PLACEMENT
            }
        });
    }

    /**
     * Track PayPal Express order placement (direct from paysheet for STH/BOPIS)
     * @param {object} orderData - Order data
     * @param {string} orderData.orderId - The order ID
     * @param {number|string} orderData.total - The order total
     * @param {string} orderData.fulfillmentType - The fulfillment type (SHIP or PICKUP)
     */
    static trackExpressOrderPlacement(orderData) {
        const { orderId, total, fulfillmentType } = orderData;

        processEvent.process(LINK_TRACKING_EVENT, {
            data: {
                pageName: 'paypal:express:order placed:n/a:*',
                pageDetail: PAYPAL_EXPRESS.PAGE_DETAIL.EXPRESS_CHECKOUT,
                linkName: PAYPAL_EXPRESS.ORDER_PLACED,
                orderId,
                orderTotal: total,
                fulfillmentType,
                internalCampaign: PAYPAL_EXPRESS.CAMPAIGN.PAYPAL_EXPRESS,
                actionInfo: PAYPAL_EXPRESS.ACTION_INFO.DIRECT_ORDER_PLACEMENT
            }
        });
    }

    /**
     * Track PayPal SDD Express fallback to checkout
     * @param {string} reason - The reason for fallback
     */
    static trackSddExpressFallback(reason) {
        processEvent.process(LINK_TRACKING_EVENT, {
            data: {
                pageName: 'paypal:sdd express:fallback:n/a:*',
                pageDetail: PAYPAL_EXPRESS.PAGE_DETAIL.CHECKOUT_REDIRECT,
                linkName: PAYPAL_EXPRESS.SDD_FALLBACK,
                errorReason: reason,
                internalCampaign: PAYPAL_EXPRESS.CAMPAIGN.PAYPAL_SDD_EXPRESS,
                actionInfo: PAYPAL_EXPRESS.ACTION_INFO.ORDER_PLACEMENT_FAILED
            }
        });
    }
}

export default PayPalExpressBindings;
